import React, { useEffect, useState } from 'react';
import { Flex, WhiteSpace } from 'antd-mobile';
import './style.scss';
import { BarsOutlined } from '@ant-design/icons';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale/vi_VN';
import enUS from 'antd/lib/locale/en_US';
import { useTranslation } from 'react-i18next';
import { setLocale } from 'yup';
import moment from 'moment';
import Navbar from './mobile_components/Navbar';
import MobileDataTable from '../../containers/MobileDataTableContainer';
import consts, { PREFIX_FRONT_URL } from '../../consts';
import LandingComponent from '../LandingComponent';
import ExchangeContainer from '../../containers/ExchangeContainer';
import MarketContainer from '../../containers/MarketContainer';
import LoginContainer from '../../containers/LoginContainer';
import VerifyEmailContainer from '../../containers/VerifyEmailContainer';
import UserInfoContainer from '../../containers/UserInfoContainer';
import QuestionAnswer from '../question_answer/QuestionAnswer';
import WalletContainer from '../../containers/WalletContainer';
import VerifyWithdrawalContainer from '../../containers/VerifyWithdrawalContainer';
import GuideComponent from '../GuideComponent';
import ReferralWithLoginComponent from '../ReferralWithLoginComponent';
import ReferralWithoutLoginComponent from '../ReferralWithoutLoginComponent';
import NotificationPageContainer from '../../containers/NotificationPageContainer';
import locales from '../../langs/validates';

const MobileComponent = () => {
  const checkLanguage = window.localStorage.getItem('LANG') === 'vi' ? viVN : enUS;

  return (
    <ConfigProvider locale={checkLanguage}>
      <Router>
        <Switch>
          <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.REFERRAL}`} key={`route_${window.c.routes.REFERRAL}`}>
            <ReferralWithLoginComponent />
          </Route>
          <Route key={`route_${window.c.routes.HOME}`}>
            <div className="flex-container">
              <div className="header">
                <div className="sub-title"><a href="#">Trustkeys</a></div>
                <div className="sub-title"><Navbar><BarsOutlined /></Navbar></div>
              </div>
              <div className="d-flex direct-column" style={{ height: 'calc(100% - 66px)' }}>
                <div style={{ flex: 1 }}>
                  <Flex>
                    <Flex.Item>
                      <h3 style={{ textAlign: 'center', padding: '0px 36px', fontWeight: '700' }}>
                        Mua và bán Bitcoin thuận
                        lợi
                        nhanh chóng
                      </h3>
                    </Flex.Item>
                  </Flex>
                  <WhiteSpace size="lg" />
                  <Flex>
                    <Flex.Item>
                      <h3 style={{ textAlign: 'center' }}>
                        Toàn bộ sức mạnh của sàn giao dịch tiền mã hóa Trustkeys giờ nằm
                        gọn
                        trong tay bạn.
                        Tải ứng dụng giao dịch tiền mã hóa của Trustkeys ngay hôm nay.
                      </h3>
                    </Flex.Item>
                  </Flex>
                  <WhiteSpace size="lg" />
                  <Flex className="appstores">
                    <Flex.Item>
                      <a
                        href="https://apps.apple.com/app/id1462406645"
                        className="appstore-bg appstore"
                        target="_blank"
                      >
                        App
                        Store
                      </a>
                    </Flex.Item>
                    <Flex.Item>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.trustkeysnetwork&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                        className="googleplay-bg appstore"
                        target="_blank"
                      >
                        Google Play
                      </a>
                    </Flex.Item>
                  </Flex>
                </div>
                <WhiteSpace size="lg" />
                <div className="data-table" style={{ flex: 1 }}>
                  <MobileDataTable />
                </div>
              </div>
            </div>
          </Route>
        </Switch>
      </Router>
    </ConfigProvider>
  );
};

export default MobileComponent;
